import { TenderStages } from "@/utils/enums";

const isDraftMode = { computed: { isDraftMode() { return !this.project.showProject } } };
const isPreBid = { computed: { isPreBid() { return this.project.tenderStageId === TenderStages.PREBID } } };
const isPrivateProject = { computed: { isPrivateProject() { return !!this.project.isPrivate } } };
const requiredForOpenProject = { computed: { requiredForOpenProject() { return !this.isDraftMode && !this.isPreBid && !this.isPrivateProject } } };
const requiredForPrebid = { computed: { requiredForPrebid() { return !this.isDraftMode && !this.isPrivateProject } } };

export { isDraftMode, isPreBid, isPrivateProject, requiredForOpenProject, requiredForPrebid }
